var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-x-0 top-0 z-50 w-full h-full bg-white flex flex-col items-center"},[_c('Logo'),_c('BaseIcon',{staticClass:"icon-spin text-primary text-5xl mt-2",attrs:{"icon":"spinner2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }